export default (initialState = {}) => {
  return () => {
    return {
      _id: "",
      name: "",
      is_gst_registered: true,
      is_active: true,
      pan: "",
      tax_settings: [],
      credit_limit: 1,
      advance_limit: 1,
      credit_cycle: 0,
      portfolio: {
        outstanding_payables: 0,
        unused_receivables: 0,
        unused_credits: 0,
      },
      ...initialState,
    };
  };
};
